import clsx from "clsx";
import React from "react";

const HandleSidePannelButton = (props) => {

    const {
        editor,
        selectedPage
    } = props;

    const [hideMenu, setHideMenu] = React.useState(false);
    
    const handleSideMenu = () => {

        if(editor.Commands.isActive('view-annotations') === false){

            const sideMenu = document.querySelectorAll('.flexProsLeftPanel')[0];
            if(sideMenu){
                if(hideMenu === false){
                    sideMenu.style.display = 'none';
                }
                else{
                    sideMenu.style.display = 'inherit';
                }
            }
            editor.refresh();
            setHideMenu(!hideMenu);
        }
    }


    const handleSideMenuButtonClasses = () => {
        if(hideMenu === false){
            if(selectedPage > -1){
                return clsx('fas', 'fa-angle-left', 'gjs-pn-btn', 'gjs-pn-btn4');
            }
            return clsx('fas', 'fa-angle-left', 'gjs-pn-btn', 'gjs-pn-btn4', 'gjs-hide-menu-width');
        }
        if(selectedPage > -1){
            return clsx('fas', 'fa-angle-right', 'gjs-pn-btn', 'gjs-pn-btn4');
        }
        return clsx('fas', 'fa-angle-right', 'gjs-pn-btn', 'gjs-pn-btn4', 'gjs-hide-menu-width');
        
    }

    return(
        
        <div
            id='handleSidePannelButton'
            data-tooltip= {hideMenu === false ? "Hide menu" : "Expand menu" }
            data-tooltip-pos="bottom"
            aria-hidden="true"
            className={handleSideMenuButtonClasses()}
            onClick={handleSideMenu}
        >
            {' '}
        </div>
    )


} 

export default HandleSidePannelButton;